import React, { useState } from 'react'

// eslint-disable-next-line 
import { Link } from 'react-router-dom'
import NavBar from "./Navbar"

import './App.css';

function App() { // eslint-disable-line no-unused-vars
  const [openModal, setOpenModal] = useState(null);

  const tutorials = [
    {
      id: 1,
      title: "Create Teacher Account and Set-Up",
      videoId: "uHkLzVQ55FA",
      width: 800,
      height: 450
    },
    {
      id: 2,
      title: "FastClassPass Grade Syncer Demo",
      videoId: "28yNqErpkDk",
      width: 800,
      height: 450
    },
    {
      id: 3,
      title: "Saving PDF from Powerschool - Which can be used to update Student Roster (contact information)",
      videoId: "EisG84HVeVY",
      width: 800,
      height: 450
    }, 
    {
      id: 4,
      title: "Adding Bulletin Items to About Page on Parent Site",
      videoId: "mH8Bez6vw4Q",
      width: 800,
      height: 450
    },
    {
      id: 5,
      title: "Student Made Pass From a Computer",
      videoId: "ZWpdFIbqnlg",
      width: 800,
      height: 450
    },
     {
      id: 6,
      title: "Displaying Top Ten of Selected Assignment on Parent Site",
      videoId: "JsF4asehgqE",
      width: 800,
      height: 450
    },
    {
      id: 7,
      title: "Teacher Made Pass From Phone & Admin View",
      videoId: "-tbMQ62LxOc",
      width: 800,
      height: 450
    },
     {
      id: 8,
      title: "Including a Link to Parent Site in Emails without Grades Information",
      videoId: "Ja78pSumsfA",
      width: 800,
      height: 450
    }
  ];

  const cardContainerStyles = {
    display: "grid", 
    gridTemplateColumns: tutorials.length % 3 === 0 ? "repeat(3, 1fr)" : "repeat(2, 1fr)",
    gap: "20px",
    marginBottom: "30px",
    padding: "20px",
    maxWidth: "1200px",
    margin: "0 auto 30px"
  };

  const cardStyles = {
    backgroundColor: "#013469",
    border: "2px solid #E43522",
    borderRadius: "8px",
    padding: "24px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "150px",
    textAlign: "center",
    fontSize: "18px",
    fontWeight: "600",
    color: "white",
    userSelect: "none"
  };

  const cardHoverStyles = {
    ...cardStyles,
    backgroundColor: "#00FF00",
    color: "black",
    boxShadow: "0 4px 12px rgba(10, 132, 255, 0.3)",
    transform: "translateY(-2px)"
  };

  const handleCardClick = (tutorialId) => {
    setOpenModal(tutorialId);
  };

  const handleCloseModal = () => {
    setOpenModal(null);
  };

  const getTutorialVideo = (tutorialId) => {
    const tutorial = tutorials.find(t => t.id === tutorialId);
    return tutorial?.videoId || "EisG84HVeVY";
  };

  const getTutorialTitle = (tutorialId) => {
    const tutorial = tutorials.find(t => t.id === tutorialId);
    return tutorial?.title || "Tutorial";
  };

  const getTutorialDimensions = (tutorialId) => {
    const tutorial = tutorials.find(t => t.id === tutorialId);
    return {
      width: tutorial?.width || 800,
      height: tutorial?.height || 450
    };
  };

  return (
    <div className="App22">
      <NavBar />
      <div className="App">
        <header className="App-header">
          <br></br>
          <div className="centerme22120">Video Tutorials
          </div>
          <br></br>

          {/* Responsive Card Grid */}
          <div style={cardContainerStyles}>
            {tutorials.map((tutorial, index) => (
              <div
                key={tutorial.id}
                style={{
                  ...(openModal === tutorial.id ? cardHoverStyles : cardStyles),
                ...(index === tutorials.length - 1 && tutorials.length % 2 !== 0 && tutorials.length % 3 !== 0 ? { justifySelf: "center" } : {})
                }}
                onClick={() => handleCardClick(tutorial.id)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#00Ff00";
                  e.currentTarget.style.color = "black";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(10, 132, 255, 0.3)";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#013469";
                  e.currentTarget.style.color = "white";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.1)";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                {tutorial.title}
              </div>
            ))}
          </div>

          {/* Video Modal */}
          {openModal && (() => {
            const dimensions = getTutorialDimensions(openModal);
            return (
              <div style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000
              }} onClick={handleCloseModal}>
                <div style={{
                  backgroundColor: "white",
                  borderRadius: "8px",
                  padding: "20px",
                  position: "relative",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  width: `${dimensions.width + 40}px`,
                  maxWidth: "90vw"
                }} onClick={(e) => e.stopPropagation()}>
                  <button
                    onClick={handleCloseModal}
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      background: "none",
                      border: "none",
                      fontSize: "28px",
                      cursor: "pointer",
                      color: "#333",
                      zIndex: 1001
                    }}
                  >
                    ✕
                  </button>
                  <iframe
                    width={dimensions.width}
                    height={dimensions.height}
                    src={`https://www.youtube.com/embed/${getTutorialVideo(openModal)}`}
                    title={getTutorialTitle(openModal)}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      borderRadius: "4px",
                      display: "block",
                    }}
                  ></iframe>
                </div>
              </div>
            );
          })()}

          {/* Support Contact Section */}
          <div className="centerme">
            For Technical Support:<br />fastclasspass@gmail.com.
              <br></br>
                <br></br>
                    <br></br>
                <br></br>
                    <br></br>
                <br></br>
          </div>
        
        </header>
      </div>
    </div>
  );
}

export default App;